import $ from 'jquery'
import _ from 'lodash'
export function limparCamposComError(itens){
    $('.campo-com-error').removeClass('campo-com-error')
}

export function marcarCampoDeItemComError(itensComError){
    itensComError.forEach(item => {
        const id = `item-${item}`
        addClassDeError(id, 'input')
    })
}

export function marcarCamposDeitensDeLiscaComError(itensDeLiscaComError){
    const lista = _.values(itensDeLiscaComError)
    const keys = Object.keys(itensDeLiscaComError)

    for(var i = 0; i < keys.length; i++){
        for(var j = 0; j < lista[i].length; j++){
            $(`#area-item-${keys[i]} #input${lista[i][j].id}`).parent().addClass('touched invalid validate')
        }
    }
}

export function addClassDeError(id, tipo = null){
    $(`#${id}`).parent().addClass('touched invalid validate')
}

export function removeClassDeError(id, tipo = null){
    if(tipo){
        $(`#${id} :${tipo}`).removeClass('campo-com-error')
    } else {
        $(`#${id}`).removeClass('campo-com-error')
    }
}


// WEBPACK FOOTER //
// ./src/helpers/validators/validatorHelps.js